module.exports = __webpack_public_path__ + "static/media/setup.2f9d7b4a.svg";